import VForm from "@/vuetify_custom/v-form";
import VBankSelector from "@/views/expense_group/components/v-bank-selector.vue";
import AutocompletesAsync from "@/vuetify_custom/v-form/components/Autocompletes_Async_v1.js";
import AutocompletesAsyncS from "@/vuetify_custom/v-form/components/Autocompletes_Async_v2.js";
// import RadioButtons from '@/vuetify_custom/v-form/components/Radio_Buttons.js'
import IsSampleTip from "./IsSampleTip.vue";
import ViewerItem from "@/views/components/viewer/item_v1.vue";
import {
  commonValidateRule,
  creatBcParams,
  getContractFkType,
  setHaveToSelect,
  canGenerateAds,
} from "./utils";
import { VBtn, VIcon } from "vuetify/lib";
import ExpenseUtil from "@/libs/expense_util";
import EditAttachments from "@/views/components/file/edit_attachments_v1";
import FileUploader from "@/views/components/file/uploader.vue";
import { getsafe } from "@/libs/util.js";
import { common_mixins } from "./EditMixIns.jsx";
import { mapGetters } from "vuex";
import Tip from "./tip.vue";
import {
  getContractDetailApi,
  getPlacingAdsRecordApi,
  getPlacingAdsVasRecordApi,
  getOutsourceContractDetailApi,
} from "./service";
import styles from "./index.module.less";
const commonValidateRuleGo = commonValidateRule("必选");
const commonValidateRuleGoS = commonValidateRule("必选", [0]);
export default {
  components: {
    Tip,
  },
  mixins: [common_mixins],
  props: {
    defaultPayee: {
      type: Array,
      default: () => [],
    },
    defaultPayeeOut: {
      type: Array,
    },
  },
  data() {
    return {
      auditUsers: [],
      payee_default: [],
      contract_items: [],
      contract_items_hash: {},
    };
  },
  computed: {
    ...mapGetters("async", ["team_company_mapping_hash"]),
    ...mapGetters({
      banks: "async/banks",
    }),
    filter_banks() {
      return this.banks.filter((item) => {
        return this.canShowItem(item);
      });
    },
    // 验证合同总金额与付款单总金额的关系
    is_compliance_contract_total() {
      // 新建的时候验证
      const pay_all = Number(
        math
          .eval(`${this.params.total_price || 0}+${this.params.have_paid || 0}`)
          .toFixed(2)
      ); // 本次总金额+合同已付金额
      const hetong_total_price = Number(this.params.hetong_total_price || 0); // 合同总价
      return hetong_total_price >= pay_all;
    },

    // 币别
    currencies() {
      return ExpenseUtil.currencies;
    },
    fields() {
      const _this = this;
      const arr = [
        {
          show: true,
          label: "单据名称",
          key: "name",
          placeholder: "简单描述事项内容",
          cols: 6,
          required: true,
          rules: [commonValidateRuleGo],
        },
        {
          show: true,
          label: "团队",
          type: "team_select",
          key: "team_id",
          required: true,
          cols: 3,
          rules: [commonValidateRuleGo],
          change: (val) => {
            const team_company_mapping_hash = this.team_company_mapping_hash;

            if (
              !team_company_mapping_hash.companyTeamCorrespond(
                val,
                this.params.company_id
              )
            ) {
              const company = team_company_mapping_hash.companyTeamCorrespondGetCompant(
                val
              );
              this.params.company_id = company && company.company_id;
            }
          },
        },
        {
          show: true,
          label: "公司",
          type: "company_select",
          key: "company_id",
          cols: 3,
          required: true,
          rules: [commonValidateRuleGo],
        },

        {
          show: true,
          label: "付款类型",
          key: "payment_purpose",
          type: "select_field_v1",
          required: true,
          items: [
            {
              title: "普通付款",
              key: "normal",
            },
            {
              title: "采购付款",
              key: "stock",
            },
            {
              title: "内部交易付款",
              key: "internal",
            },
            {
              title: "兼职外包付款",
              key: "outsource",
            },
            {
              title: "充值付款",
              key: "recharge",
            },
            {
              title: "薪酬类付款",
              key: "salary",
            },
          ],
          cols: 3,
          rules: [commonValidateRuleGo],
          change: (val) => {
            _this.changePaymentPurpose(val);
          },
        },
        {
          show: _this.params.payment_purpose === "outsource",
          label: "兼职外包付款平台",
          key: "kind",
          type: "select_field_v1",
          disabled: true,
          items: [
            {
              title: "51社保",
              key: "shebao51",
            },
            {
              title: "云账户",
              key: "yunzhanghu",
            },
          ],
          cols: 3,
        },
        {
          show: this.params.payment_purpose !== "outsource",
          label: "关联合同",
          key: "contract_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          "item-text": "uid_name",

          out_params: {
            payment_purpose: _this.params.payment_purpose,
            //   team_id: _this.params.team_id
          },
          api: this.$util.api.contract_select_search,
          // init_list: [], // this.apply_user_list,
          cols: 6,
          required: true,
          rules: [
            commonValidateRuleGo,
            () => {
              if (
                _this.params.contract_company_id &&
                _this.params.company_id &&
                _this.params.contract_company_id !== _this.params.company_id
              ) {
                return "付款申请中的公司与合同的我方公司必须保持一致！若有疑问请联系财务公共账号";
              }
              return true;
            },
          ],
          items: this.contract_items.filter(
            (i) => i.uid.slice(0, 4) === "HTBC"
          ),

          handle_data: ({ contracts = [] } = {}) => {
            _this.contractItemsChange(contracts, false, "contract_id");
          },
          change: (_, target = {}) => {
            _this.changeContract(target);
          },
          scopedSlots: {
            "append-outer": () => {
              return (
                <div
                  style={{
                    display: !_this.params.contract_id ? "none" : "block",
                  }}
                >
                  <ViewerItem
                    type="Contract"
                    modelId={_this.params.contract_id}
                  >
                    <VBtn
                      icon
                      color={_this.params.contract_id ? "primary" : ""}
                    >
                      <VIcon>mdi-details</VIcon>
                    </VBtn>
                  </ViewerItem>
                </div>
              );
            },
          },
        },
        {
          show: this.params.payment_purpose === "outsource",
          label: "关联兼职外包合同",
          key: "outsource_contract_id",
          // initList: [],
          type: "autocompletes_async_v1",
          "item-value": "id",
          "item-text": "uid_name",
          out_params: {
            //  platform: 'common'
            finished: true
          },
          api: this.$util.api.outsource_contract_select_search,
          cols: 6,
          required: true,
          items: this.contract_items.filter(
            (i) => i.uid.slice(0, 4) !== "HTBC"
          ),
          rules: [commonValidateRuleGo],
          handle_data: ({ contracts = [] } = {}) => {
            _this.contractItemsChange(
              contracts,
              false,
              "outsource_contract_id"
            );
          },
          change: (_, target = {}) => {
            _this.changeOutsourceContract(target);
          },
        },
        {
          show: this.params.is_financer,
          key: "my_accont",
          label: "付款账户",
          placeholder: "请选择付款账户账户",
          rules: [commonValidateRuleGoS],
          cols: 6,
        },
        {
          show: true,
          label: "收款账户",
          key: "payee_company_account_id",
          type: "autocompletes_async_v1",
          disabled: this.params.payment_purpose === "outsource",
          "item-value": "id",
          api: this.$util.api.payee_company_account_select_search,
          "item-text": "text_name",
          placeholder: "与开店主体的对应银行一致",
          initList:
            this.params.payment_purpose === "outsource"
              ? this.defaultPayeeOut
              : [..._this.defaultPayee, ..._this.payee_default],
          cols: 6,
          out_params:
            this.params.payment_purpose === "outsource"
              ? {
                  type: "person",
                }
              : {
                  type: "all",
                  apply_user_id: _this.params.apply_user_id,
                },
          required: true,
          rules: [
            (val) => {
              return !!val || "收款账户必选";
            },
          ],
          handle_data: ({ accounts }) => {
            return accounts.map((item) => ({
              ...item,
              text_name: `${item.bank_number}-${item.bank_account}-${item.bank}`,
            }));
          },
          change: (data, target) => _this.changeReceipt(target),
        },
        {
          show: !this.params.is_financer,
          type: "empty",
          cols: 6,
        },
        {
          show: true,
          label: "币种",
          key: "currency",
          type: "select_field_v1",
          required: true,
          items: _this.currencies.map((item) => {
            return {
              ...item,
              title: `${item.symbol}-${item.label}`,
              key: item.value,
            };
          }),
          cols: 3,
          rules: [commonValidateRuleGo],
          change: () => {
            _this.$emit("changeCurrency");
          },
        },
        {
          show: true,
          label: "总金额（原币）", // 跟着币种走
          key: "total_price",
          placeholder: (!_this.params.is_jianyi && "自动计算") || "",
          readonly: !_this.params.is_jianyi,
          type: "number_field",
          cols: 3,
          rules: [
            commonValidateRuleGo,
            () => {
              if (
                _this.params.payment_purpose === "outsource" || // 兼职外包不做校验
                this.params.is_open_contract || // 开口合同不做校验
                !!this.params.id || // 编辑时不做校验
                this.is_compliance_contract_total
              ) {
                return true;
              }
              return "本次支付金额超出合同剩余可支付金额";
            },
            () => {
              // 如果有合同结算款项
              if (
                this.params.expense_group_settlements &&
                this.params.expense_group_settlements.length &&
                !_this.validSettlements(this.params.expense_group_settlements)
              ) {
                return "合同结算款项本次支付金额需等于总金额";
              }
              return true;
            },
            (val) => {
              const has_placing_ads_records =
                this.params.placing_ads_records &&
                this.params.placing_ads_records.length;
              const has_placing_ads_vas_records =
                this.params.placing_ads_vas_records &&
                this.params.placing_ads_vas_records.length;
              if (!has_placing_ads_records && !has_placing_ads_vas_records) {
                return true;
              }
              return (
                Number(val) === Number(this.params.placing_ads_records_sum) ||
                "投放记录与加成服务的金额需与总金额相等"
              );
            },
          ],
        },
        {
          show: !this.params.is_financer,
          type: "empty",
          cols: 3,
        },
        {
          show: this.params.is_financer,
          label: "总金额（本位币）", // 人民币
          key: "cny_total_price",
          // placeholder: _this.params.currency === "CNY" && '自动计算' || '',
          type: "number_field",
          cols: 3,
        },
        {
          show: true,
          type: "empty",
          cols: 3,
        },
        {
          show: this.params.is_financer || this.is_financer_assistant,
          // disabled: this.params.payment_purpose === 'salary',
          label: "是否补单",
          type: "radio_buttons",
          key: "is_simple",
          cols: 3,
          rules: [
            commonValidateRuleGo,
            (val) => {
              if (this.params.payment_purpose === "salary" && !val) {
                return "[付款类型-薪酬类付款]必须选择 是 ";
              }
              return true;
            },
          ],
          scopedSlots: {
            label: () => {
              return (
                <div>
                  <span>
                    <span style="color:red">*</span>是否补单
                    <span>
                      <IsSampleTip />
                    </span>
                  </span>
                </div>
              );
            },
          },
          row: true,
          items: [
            {
              value: true,
              key: true,
              label: "是",
            },
            {
              value: false,
              key: false,
              label: "否",
            },
          ],
        },
        {
          show: true,
          label: "跨公司付款",
          type: "radio_buttons",
          key: "can_cross_company",
          cols: 3,
          row: true,
          change: (val) => {
            // 不是跨公司付款，主体不一致时清空
            const is_not =
              !val && this.params.sk_company_id !== this.params.company_id;
            if (is_not) {
              this.setBank();
            }
          },
          items: [
            {
              value: true,
              key: true,
              label: "是",
            },
            {
              value: false,
              key: false,
              label: "否",
            },
          ],
        },
        {
          show: this.params.is_financer || this.is_financer_assistant,
          label: "付款日期",
          key: "paid_at",
          type: "date_picker_v1",
          cols: 3,
          clearable: true,
          disabled: this.params.is_period_closed,
          placeholder: "CBS/云账户无需填写",
          // rules: [commonValidateRuleGo],
        },
        {
          show: this.params.is_financer || this.is_financer_assistant,
          label: "入账会计期",
          key: "verified_at",
          type: "date_picker_v1",
          cols: 3,
          disabled: this.params.is_period_closed,
          clearable: true,
          // placeholder: ''
          // rules: [commonValidateRuleGo],
        },
        {
          show: _this.params.payment_purpose === "outsource",
          label: "实际交付内容",
          type: "textareas_field",
          key: "purpose",
          counter: 500,
          rows: 5,
          cols: 8,
          rules: [
            (val) => {
              return !!val || "必填";
            },
          ],
          scopedSlots: {
            label: () => {
              return (
                <span>
                  <span style="color:red">*</span>实际交付内容
                </span>
              );
            },
            "prepend-inner": () => {
              return (
                <span style="cursor: pointer;">
                  {" "}
                  <Tip />
                </span>
              );
            },
          },
        },
        {
          show: this.params.is_financer && this.params.is_cbs,
          label: "摘要",
          type: "textareas_field",
          key: "cbs_remark",
          cols: 8,
        },
        {
          show: true,
          label: "单据备注",
          type: "textareas_field",
          key: "desc",
          cols: 8,
        },
        {
          show: true,
          cols: 8,
          key: "upload",
        },
      ];

      return arr.filter((i) => i.show);
    },
  },
  watch: {
    "params.company_id"(n_v) {
      if (n_v !== this.params.sk_company_id) {
        this.setBank();
      }
      this.$nextTick(() => {
        this.handleBank();
      });
    },
  },
  created() {
    // 建立vuex的引用关系（没有实质用处）
    this.team_company_mapping_hash;
  },
  methods: {
    canShowItem(item) {
      return (
        this.params.can_cross_company ||
        (this.params.company_id && this.params.company_id === item.company_id)
      );
    },
    // 付款类型为兼职外包付款，并且选择了公司，自动选择云账户
    handleBank() {
      const banks = this.filter_banks.filter((item) => !item.del);
      if (this.params.payment_purpose === "outsource" && banks.length > 0) {
        for (const bank of banks) {
          if (
            bank.bank &&
            bank.bank.includes("云账户") &&
            bank.account.includes("M")
          ) {
            this.setBank(bank);
          }
        }
      }
    },
    // 付款类型为兼职外包付款的时候，自动填写发票信息
    // 银行流水生成付款单 专属
    getFKZH(bank_number) {
      const arr = this.$refs.fkzh.getFilterBanks() || [];
      const hash = arr.reduce((total, item) => {
        total[item.bank_number] = item;
        return total;
      }, {});
      const target = bank_number && hash && hash[bank_number];
      if (target) {
        this.setBank(target);
      }
    },
    changePaymentPurpose() {
      this.changeContract();
      this.changeOutsourceContract();
      this.contract_items = [];
      this.contract_items_hash = {};
      //    if (val === 'salary') {
      //     this.params.is_simple = true
      //    }
    },
    contractItemsChange(contracts = [], is_clear, type) {
      let name_key = "";
      if (is_clear) {
        this.contract_items = [];
        this.contract_items_hash = {};
      }
      switch (type) {
        case "contract_id":
          name_key = "name";
          break;
        case "outsource_contract_id":
          name_key = "account";
          break;
        default:
          break;
      }
      console.log("contract items change", {contracts, is_clear, type})
      contracts.forEach((item) => {
        if (this.contract_items_hash[item.id]) {
          return;
        }
        this.contract_items_hash[item.id] = true;
        this.contract_items.push({
          ...item,
          uid_name: `${item.uid}-${item[name_key]}`,
        });
      });
    },
    changeOutsourceContract(
      target = {},
      { expense_group, need_change = true, need_receipt = true } = {}
    ) {

      console.log("change contract")
      console.log({
        target,
        expense_group,
        need_change,
        need_receipt
      })

      this.params.is_recharge = null;
      this.params.hetong_total_price = target.estimate_price;
      this.params.contract_nature = null;
      this.params.kind = target.platform;
      this.params.outsource_contract_id = target.id;
      this.params.have_paid = 0;
      this.params.expense_group_settlements = [];
      if (!expense_group) {
        // 编辑时不改变团队信息
        this.params.team_id = target.team_id;
        this.params.company_id = target.company_id;
      }
      if (need_change) {
        this.params.tfjc_type = 0;
        this.params.placing_ads_records = [];
        this.params.placing_ads_vas_records = [];
        if (target.id) {
          getOutsourceContractDetailApi({ id: target.id }).then((res) => {
            // 自动填写会科目&分析科目
            const contract = res.contract;
            if (contract.analysis_title_id) {
              this.$set(
                this.params,
                "expenses",
                this.params.expenses.map((item) => ({
                  ...item,
                  account_title_id: contract.account_title_id,
                  analysis_title_id: contract.analysis_title_id,
                }))
              );
            }
            setTimeout(() => {
              getPlacingAdsRecordApi(this.tf_records_out_params).then((res) => {
                res = res || [];
                this.params.placing_ads_records = res.map((i) => {
                  return {
                    ...i,
                    have_paid_amount:
                      Number(i.payable_price) ||
                      Number(i.total_price) - Number(i.paid_price) ||
                      0,
                  };
                });
              });
              getPlacingAdsVasRecordApi(this.jc_records_out_params).then(
                (res) => {
                  res = res || [];
                  this.params.placing_ads_vas_records = res;
                }
              );
            });
          });
        }
      }
      if (need_receipt && target && target.id) {
        let receipt_target = undefined;
        receipt_target = {
          payee_company_name: getsafe(target, "payee_company.name"),
          bank: getsafe(target, "payee_company_account.bank"),
          bank_account: getsafe(target, "payee_company_account.account"), // account
          bank_number: getsafe(target, "payee_company_account.bank_number"), // bank_number
          id: getsafe(target, "payee_company_account.id"), // id
          payee_company_id: getsafe(
            target,
            "payee_company_account.payee_company_id"
          ), // payee_company_id
          remark: getsafe(target, "payee_company_account.remark"),
        };
        console.log('匹配收款账户', receipt_target)
        receipt_target.text_name = `${receipt_target.bank_number}-${receipt_target.bank_account}-${receipt_target.bank}`;
        this.$emit("setDefaultPayeeOut", receipt_target);
        this.changeReceipt(receipt_target);
      }
      // this.$emit('setPayeeArrOut', target.id ? target : null)
      this.params.contract_source = target;
      // this.changeReceipt(target.payee_company_account, true)
    },
    edithandleContractDetail(expense_group) {
      const _contract_settlements = expense_group.expense_group_settlements;
      // 获取当前收款账户
      if (expense_group && expense_group.payee_company_account_id) {
        this.changeReceiptEdit(expense_group);
      }
      // 合同结算款项
      if (_contract_settlements && _contract_settlements.length) {
        const _contract_settlements_hash = _contract_settlements.reduce(
          (t, i) => {
            t[i.contract_settlement_id] = i;
            return t;
          },
          {}
        );
        this.params.expense_group_settlements.forEach((i) => {
          const contract_settlement =
            _contract_settlements_hash[i.contract_settlement_id] || {};
          i.payment_amount = contract_settlement.payment_amount;
        });
        // console.log('this.params.expense_group_settlements', this.params.expense_group_settlements)
      }
    },
    //
    changeContract(target = {}, { expense_group, need_change = true } = {}) {
      // expense_group
      //  const _contract_settlements = expense_group.expense_group_settlements
      const contract_settlements = target.contract_settlements || [];
      // payee_company_id
      /* 前端用于展示与判断 */
      this.params.is_open_contract = target.contract_nature === "open";
      this.params.is_recharge = !!target.contract_recharge;
      this.params.hetong_total_price = target.total_price;
      this.params.contract_nature = target.contract_nature;
      this.params.have_paid = target.have_paid;
      this.params.contract_company_id = target.company_id;
      this.params.contract_payee_company_id = target.payee_company_id;
      this.params.kind = null;
      this.params.contract_invoices = target.contract_invoices || [];
      /* -------------- */
      /* -------------- */
      this.params.contract_id = target.id;
      //
      this.params.expense_group_settlements = contract_settlements.map(
        (item) => ({
          ...item,
          appoint_payment_amount: item.payment_amount,
          contract_settlement_id: item.id,
          payment_amount: null,
        })
      );
      // 入口时是编辑
      if (expense_group) {
        this.edithandleContractDetail(expense_group);
      } else {
        /* 表单联动 */
        this.params.team_id = target.team_id;
        this.params.company_id = target.company_id;
        this.changeReceipt(target.payee_company_account, true);
        this.params.expense_group_recharge = creatBcParams();
        if (this.params.is_recharge) {
          this.params.expense_group_recharge = {
            recharge_type: target.recharge_type,
            recharge_amount: target.contract_recharge,
            consumption_mode: target.contract_recharge,
            refundable: target.contract_recharge,
          };
        }
        if (!this.params.payment_purpose) {
          this.params.payment_purpose = getContractFkType(target);
        }
      }

      // 编辑获取本次支付金额
      // if (_contract_settlements && _contract_settlements.length) {
      //     const _contract_settlements_hash = _contract_settlements.reduce((t, i) => {
      //         t[i.contract_settlement_id] = i
      //         return t
      //     }, {})
      //     this.params.expense_group_settlements.forEach(i => {
      //         const contract_settlement = _contract_settlements_hash[i.contract_settlement_id] || {}
      //         i.payment_amount = contract_settlement.payment_amount
      //     })
      //     // console.log('this.params.expense_group_settlements', this.params.expense_group_settlements)
      // }
      // // 获取当前的收款账户
      // if (expense_group && expense_group.payee_company_account_id) {
      //     this.changeReceiptEdit(expense_group)
      // } else {

      // }

      if (!this.params.payment_purpose) {
        this.params.payment_purpose = getContractFkType(target);
      }
      /* 投放记录相关 */
      // 判断该合同是否必须要关联投放记录
      this.params.have_to_select_tf = setHaveToSelect(target);
      this.params.contract_source = target;
      if (need_change) {
        this.params.tfjc_type = 0;
        this.params.placing_ads_records = [];
        this.params.placing_ads_vas_records = [];
        if (target.id) {
          if (canGenerateAds(target)) {
            getContractDetailApi({ id: target.id }).then(() => {
              setTimeout(() => {
                getPlacingAdsRecordApi(this.tf_records_out_params).then(
                  (res) => {
                    res = res || [];
                    this.params.placing_ads_records = res.map((i) => {
                      return {
                        ...i,
                        have_paid_amount:
                          Number(i.payable_price) ||
                          Number(i.total_price) - Number(i.paid_price) ||
                          0,
                      };
                    });
                  }
                );
                getPlacingAdsVasRecordApi(this.jc_records_out_params).then(
                  (res) => {
                    res = res || [];
                    this.params.placing_ads_vas_records = res;
                  }
                );
              });
            });
          }
        }
      }

      // this.tf_records_out_params
    },
    // 收款账户相关
    changeReceipt(target = {}, auto_get) {
      target = target || {};
      if (auto_get && target.id) {
        this.payee_default = [
          {
            ...target,
            text_name: `${target.bank_number}-${target.bank_account}-${target.bank}`,
          },
        ];
      }
      this.params.payee_company_account_id = target.id;
      this.params.payee_user_id = 0;
      this.params.payee_user = "";
      this.params.payee_bank = target.bank;
      this.params.payee_account_name = target.bank_account;
      this.params.payee_bank_number = target.bank_number;
      this.params.payee_company_id = target.payee_company_id;
      this.params.payee_company = target.payee_company_name;
    },
    changeReceiptEdit(target = {}) {
      this.payee_default = [
        {
          id: target.payee_company_account_id,
          bank: target.payee_bank,
          bank_account: target.payee_account_name,
          bank_number: target.payee_bank_number,
          payee_company_id: target.payee_company_id,
          payee_company_name: target.payee_company,
          text_name: `${target.payee_bank_number}-${target.payee_account_name}-${target.payee_bank}`,
        },
      ];
      this.params.payee_company_account_id = target.payee_company_account_id;
      this.params.payee_user_id = 0;
      this.params.payee_user = "";
      this.params.payee_bank = target.payee_bank;
      this.params.payee_account_name = target.payee_account_name;
      this.params.payee_bank_number = target.payee_bank_number;
      this.params.payee_company_id = target.payee_company_id;
      this.params.payee_company = target.payee_company;
    },
    // 付款相关
    setBank(bank = {}) {
      this.params.sk_company_id = bank.company_id;
      this.params.expense_payment_bank_id = bank.id;
      this.params.payment_bank_name = bank.bank;
      this.params.payment_bank_account = bank.account;
      this.params.payment_bank_number = bank.bank_number;
    },
    validSettlements(arr = []) {
      arr = arr || [];
      let total = 0;
      arr.forEach((item) => {
        total = math.eval(`${total}+${item.payment_amount || 0}`);
      });
      return Number(total.toFixed(2)) === Number(this.params.total_price);
    },
  },
  render() {
    const _this = this;
    return (
      <VForm
        ref="base"
        fields={_this.fields}
        v-model={_this.params}
        scopedSlots={{
          my_accont: ({ field } = {}) => {
            return (
              <VBankSelector
                ref="fkzh"
                required
                rules={field.rules}
                v-model={_this.params.expense_payment_bank_id}
                label={field.label}
                canCrossCompany={_this.params.can_cross_company}
                checkPaymentFinBill
                companyId={_this.params.company_id}
                on={{
                  change: (...arg) => {
                    const cur = arg[0];
                    //    console.log('cur', cur)
                    //    // kingdee_settle_type:yzh
                    _this.params.is_cbs = cur.is_cbs;
                    _this.params.is_yzh_cbs_51 =
                      cur.is_cbs || cur.kingdee_settle_type === "yzh";
                    //    console.log('cur', cur)
                    //    if (!_this.params.is_yzh_cbs) {
                    //     _this.params.is_simple = true
                    //    }
                    //    if (cur && !cur.is_cbs) {
                    //     _this.params.is_simple = false
                    //    }
                    _this.setBank(...arg);
                  },
                }}
              />
            );
          },
          outsource_contract_id: ({ field } = {}) => {
            return <AutocompletesAsyncS v-model={_this.params} field={field} />;
          },
          payee_company_account_id: ({ field } = {}) => {
            return (
              <div style="position:relative">
                <AutocompletesAsync v-model={_this.params} field={field} />
                {this.params.payee_company_id &&
                  this.params.contract_payee_company_id &&
                  this.params.payee_company_id !==
                    this.params.contract_payee_company_id && (
                    <p class={styles["warning-text"]}>
                      收款账户与合同中对方账户信息不一致，请联系财务公共账号及时处理
                    </p>
                  )}
              </div>
            );
          },
          contract_id: ({ field } = {}) => {
            return <AutocompletesAsyncS v-model={_this.params} field={field} />;
          },
          upload: () => {
            return (
              <div style="display:flex">
                <p style="width:40px">附件</p>
                <div style="flex:1">
                  <EditAttachments
                    files={_this.params.bfiles}
                    modelType="ExpenseGroup"
                    modelId={_this.params.id}
                  />
                  <FileUploader
                    validateFile={(file) => {
                      const a = /\.[0-9a-zA-Z]+$/.test(file.name);
                      if (!a) {
                        this.$vModal.warning({
                          title: "提示",
                          content:
                            "文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的",
                        });
                      }
                      return a;
                    }}
                    on={{
                      uploaded: (bfile) => {
                        _this.params.bfiles.push(bfile);
                      },
                    }}
                  />
                  <span class="color-error">
                    为保证兼容性及文档可编辑性，请上传office系列的文档(Word,
                    Excel, PPT)
                  </span>
                </div>
              </div>
            );
          },
          // is_simple: ({field} = {}) => {
          //     return <div>
          //             <RadioButtons
          //                 v-model={_this.params}
          //                 field={field}

          //             />
          //             <div class={styles['s-explain']}>
          //                 什么情况是线下支付：
          //                 <ul >
          //                     <li>1. 转款时需要特殊备注；</li>
          //                     <li>2. 需要支付外币（如境外版权采购）</li>
          //                 </ul>
          //             </div>
          //         </div>
          // }
        }}
      />
    );
  },
};
